module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226695761_07_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_08_int#int"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("Ina Ganguli, Shulamit Kahn, and Megan MacGarvie")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_09_pt1#ptI"
    }
  }, [_vm._v("I. LOCATION CHOICES OF INTERNATIONAL STUDENTS AND RETURN MIGRATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226695761_10_ch1#ch1"
    }
  }, [_c('strong', [_vm._v("1. Return Migrants’ Self-Selection: Evidence for Indian Inventors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Stefano Breschi, Francesco Lissoni, and Ernest Miguelez")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_11_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Will the US Keep the Best and the Brightest (as Postdocs)? Career and Location Preferences of Foreign STEM PhDs")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("Ina Ganguli and Patrick Gaulé")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_12_pt2#ptII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. IMMIGRATION POLICY AND INNOVATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_13_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. High-Skill Immigration, Innovation, and Creative Destruction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Gaurav Khanna and Munseob Lee")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_14_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. New Data and Facts on H-1B Workers across Firms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Anna Maria Mayda, Francesc Ortega, Giovanni Peri, Kevin Shih, and Chad Sparber")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226695761_15_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. Immigration and Invention: Does Language Matter?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("Kirk Doran and Chungeun Yoon")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_16_pt3#ptIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. IMMIGRATION AND ENTREPRENEURSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_17_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. Immigrant Entrepreneurs and Innovation in the US High-Tech Sector")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("J. David Brown, John S. Earle, Mee Jung Kim, and Kyung Min Lee")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_18_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7. Immigrant Networking and Collaboration: Survey Evidence from CIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Sari Pekkala Kerr and William R. Kerr")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_19_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8. Are Foreign STEM PhDs More Entrepreneurial? Entrepreneurial Characteristics, Preferences, and Employment Outcomes of Native and Foreign Science and Engineering PhD Students")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("Michael Roach, Henry Sauermann, and John Skrentny")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_20_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_21_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_22_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226695761_23_ind1#ind1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea6a966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226695761_06_toc.vue
// module id = 72
// module chunks = 0